import API from './api';

export const runOperationalReport = (reportType, params = {}) => {
  return API.get(`/reports/${reportType}`, { params });
};

export const listMotivationMessages = (params = {}) =>
  API.get('/reports/motivation-messages', { params });

export const listInsuranceRemovalRequests = (params = {}) =>
  API.get('/reports/insurance-removal-requests', { params });
